import React, { useMemo } from 'react';
import { Box, Flex, Circle, Text } from '@tapresearch/ui/components';
export var LineChartSliceTooltip = function(param) {
    var slice = param.slice, axis = param.axis, visiblePoints = param.visiblePoints, waveNumber = param.waveNumber, usePercentage = param.usePercentage;
    var otherAxis = axis === 'x' ? 'y' : 'x';
    var orderedPoints = useMemo(function() {
        return slice.points.slice().reverse().filter(function(_, i) {
            return !visiblePoints.length ? true : visiblePoints.includes(i);
        }).sort(function(a, b) {
            return Number(b.data.yFormatted) - Number(a.data.yFormatted);
        });
    }, [
        visiblePoints,
        slice.points
    ]);
    var sliceDate = orderedPoints[0].data.x;
    return /*#__PURE__*/ React.createElement(Box, {
        rounded: "md",
        border: "1px solid",
        borderColor: "gray.100",
        boxShadow: "2xl",
        bg: "white",
        overflow: "hidden",
        p: 2,
        minW: "250px"
    }, /*#__PURE__*/ React.createElement(Flex, {
        justify: "space-between",
        align: "center",
        py: 3,
        px: 1,
        mx: 2,
        mb: 2,
        color: "gray.700",
        fontSize: "md",
        fontWeight: "medium",
        borderBottom: "1px solid",
        borderBottomColor: "gray.100"
    }, "Wave #", waveNumber, /*#__PURE__*/ React.createElement(Flex, {
        grow: 1,
        fontWeight: "normal",
        color: "gray.300",
        justify: "flex-end"
    }, sliceDate)), /*#__PURE__*/ React.createElement(Box, {
        pb: 2,
        px: 4,
        my: 2
    }, orderedPoints.map(function(point, index) {
        var pointData = point.data["".concat(otherAxis, "Formatted")];
        return /*#__PURE__*/ React.createElement(Flex, {
            key: "row-".concat(index),
            justifyContent: "space-between",
            alignItems: "center",
            my: 2,
            py: 1,
            _last: {
                mb: 0
            }
        }, /*#__PURE__*/ React.createElement(Circle, {
            as: Flex,
            alignItems: "center",
            bgColor: point.serieColor,
            h: 3,
            w: 3
        }), /*#__PURE__*/ React.createElement(Text, {
            as: "span",
            fontSize: "sm",
            ml: 2,
            textAlign: "left",
            flexGrow: 1
        }, point.serieId), /*#__PURE__*/ React.createElement(Text, {
            as: "span",
            fontSize: "sm",
            ml: 3,
            fontWeight: "bold"
        }, parseFloat(pointData) ? "".concat(+parseFloat(pointData).toFixed(2)).concat(usePercentage ? '%' : '') : pointData));
    })));
};
